<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-2">{{ "Merchandise Transactions" }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-4 col-xl-3 align-self-center mb-2">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <!-- Transaction Date From-->
          <div class="col-lg-4 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  v-if="from_date"
                  v-on:click="clearDate('from_date')"
                  class="btn-clearDate"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="from_date"
                  name="selectenddate_1"
                  id="selectenddate_1"
                  v-validate="'required'"
                  :typeable="true"
                ></Datepicker>
                <label :class="from_date ? 'active' : ''">{{
                  $t("fromdate")
                }}</label>
              </div>
            </div>
          </div>

          <!-- Transaction Date To -->
          <div class="col-lg-4 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  v-if="to_date"
                  v-on:click="clearDate('to_date')"
                  class="btn-clearDate"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="to_date"
                  name="selectenddate_3"
                  id="selectenddate_3"
                  v-validate="'required'"
                  :typeable="true"
                ></Datepicker>
                <label :class="to_date ? 'active' : ''">{{
                  $t("todate")
                }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-3">
            <b-form-input
              v-model="searchValue"
              v-debounce:800="onSearch"
              placeholder="Search..."
            ></b-form-input>
          </div>

          <div class="col-lg-3 col-xl-2 mb-1">
            <multiselect
              :options="Tags"
              v-model="merch_tags"
              :multiple="false"
              :placeholder="'Tags'"
              label="m_tag_name"
              track-by="m_tag_id"
              style="min-width: 210px"
            ></multiselect>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              :disabled="btenable"
              @click.prevent.stop="getMerchandiseTransactions"
              class="btn btn-primary w-50"
            >
              {{ $tc("fetch") }}
            </button>
          </div>

          <div class="col-xl-12 d-flex justify-content-end">
            <div class="mr-2 d-flex">
              <span
                v-if="MerchandiseTransactions.length > 0"
                class="mr-3 align-self-center d-flex justify-content-end align-items-center"
              >
                <div class="mx-1">{{ $t("download") }} as:</div>
                <b-dropdown
                  size="sm"
                  variant="link"
                  toggle-class="p-0 text-decoration-none"
                  no-caret
                >
                  <template #button-content>
                    <img
                      class="mx-1"
                      src="@/assets/img/icons/excel.svg"
                      height="25"
                      width="25"
                    />
                  </template>
                  <b-dropdown-item>
                    <a
                      target="_blank"
                      @click="getMerchandiseTransactions('Y', 'bill')"
                      title="Bill Wise Exports"
                      download
                    >
                      Bill Wise Exports
                    </a>
                  </b-dropdown-item>
                  <b-dropdown-item>
                    <a
                      target="_blank"
                      @click="getMerchandiseTransactions('Y')"
                      title="Item Wise Exports"
                      download
                    >
                      Item Wise Exports
                    </a>
                  </b-dropdown-item>
                </b-dropdown>
              </span>
              <b-dropdown id="listview" variant="outline-blue">
                <template v-slot:button-content>
                  Viewing&nbsp;
                  <strong>{{ selectedvalue }}</strong>
                  &nbsp;Of&nbsp;
                  <strong>{{ rows }}</strong>
                </template>
                <b-dropdown-item
                  v-for="(list, listIndex) in viewingnumbers"
                  :key="listIndex"
                  @click="onDropDownChangeValue(list.name)"
                  href="#"
                  >{{ list.name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="swc-report">
          <table class="swc-report-table mb-3" border="1">
            <thead style="background-color: #f5f5f7">
              <tr class="bg-lightgrey">
                <th>Cinema Name</th>
                <th>Booking User</th>
                <th>Channel</th>
                <th>Cust Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Booking Date & Time</th>
                <th>Booking Code</th>
                <th>Item</th>
                <th>Item Qty</th>
                <th>Item Size</th>
                <th>Net Price</th>
                <th>Tax Price</th>
                <th>Gross Price</th>
                <th>Offer|Vouchers</th>
                <th>Comment</th>
                <th>MISC Item | MISC Amount</th>
                <th>VAT (5%)</th>
                <th>Discount</th>
                <th>Total Amount</th>
              </tr>
            </thead>
            <tbody
              v-for="(trx, trxIndex) in MerchandiseTransactions"
              :key="trxIndex"
              class="sph-report light_grey_back"
            >
              <tr>
                <td class="text-right">{{ trx.cine_name || "-" }}</td>
                <td class="text-right">{{ trx.booking_user || "-" }}</td>
                <td class="text-right">{{ trx.booking_source || "-" }}</td>
                <td class="text-right">{{ trx.customer_name || "-" }}</td>
                <td class="text-right">{{ trx.cust_mobile || "-" }}</td>
                <td class="text-right">{{ trx.cust_email || "-" }}</td>
                <td class="text-right">
                  {{ moment(trx.created_at).format("YYYY-MM-DD") }}
                </td>
                <td class="text-right">{{ trx.booking_code || "-" }}</td>
                <td class="text-right">{{ trx.merchandise_name || "-" }}</td>
                <td class="text-right">{{ trx.quantity || "-" }}</td>
                <td class="text-right">{{ trx.variant_name || "-" }}</td>
                <td class="text-left">
                  {{
                    parseFloat(trx.m_net_amount || 0).toFixed(
                      MIN_FRACTION_DIGITS
                    )
                  }}
                </td>
                <td class="text-left">
                  {{
                    parseFloat(trx.m_tax_amount || 0).toFixed(
                      MIN_FRACTION_DIGITS
                    )
                  }}
                </td>
                <td class="text-left">
                  {{
                    parseFloat(trx.m_gross_amount || 0).toFixed(
                      MIN_FRACTION_DIGITS
                    )
                  }}
                </td>
                <td class="text-right">
                  {{ trx.voucher_code || "-" }}
                </td>
                <td class="text-right">{{ trx.remarks }}</td>
                <td class="text-left">
                  {{
                    parseFloat(trx.internet_handling_fee || 0).toFixed(
                      MIN_FRACTION_DIGITS
                    )
                  }}
                </td>
                <td class="text-left">
                  {{ parseFloat(trx.tax_1 || 0).toFixed(MIN_FRACTION_DIGITS) }}
                </td>
                <td>
                  {{
                    parseFloat(trx.m_offer_price || 0).toFixed(
                      MIN_FRACTION_DIGITS
                    )
                  }}
                </td>
                <td class="text-left">
                  {{
                    parseFloat(
                      parseFloat(trx.m_gross_amount || 0) +
                        parseFloat(trx.internet_handling_fee || 0)
                    ).toFixed(MIN_FRACTION_DIGITS)
                  }}
                </td>
              </tr>
            </tbody>
            <tbody v-if="MerchandiseTransactions.length == 0">
              <tr>
                <td colspan="20">
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <br />
      <b-pagination
        v-if="MerchandiseTransactions.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
        class="my-3"
      ></b-pagination>
    </div>
    <div ref="onPrint" class="d-none">
      <div v-html="EjsData"></div>
    </div>
  </div>
</template>
<script>
import moment from "moment-timezone";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import _ from "lodash";
import Printd from "printd";
import NoRecords from "@/components/Partials/NoRecords.vue";
import { createQueryString } from "@/services/ApiHelper";
import MarketingService from "@/services/MarketingService";
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";

export default {
  components: { DatePicker, Multiselect, NoRecords },
  data() {
    return {
      from_date: moment().toDate(),
      to_date: new Date(),
      cinema_id: null,
      MerchandiseTransactions: [],
      searchValue: "",
      btenable: false,
      isSearchLoading: false,
      selectedCinema: "",
      Cinemas: [],
      Tags: [],
      merch_tags: [],
      EjsData: null,
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [],
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
    };
  },
  beforeMount() {
    // this.getMerchandiseTransactions();
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.getCinemaList(obj);
    this.getMerchandiseTags();
    this.getviewingnumber();
  },
  watch: {},
  computed: {},
  methods: {
    createQueryString,
    getMerchandiseTags: function () {
      this.Tags = [];
      let payload = {
        tableName: "ms_merchandise_tags",
        tag_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Tags = data.Records;
            }
          } else {
            this.$toasted.show(data.message || this.AdminError);
          }
        })
        .catch(this._CatchError);
    },
    onSearch() {
      this.currentPage = 1;
      this.getMerchandiseTransactions();
    },
    moment,
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.cinema_id = event.cine_id;
    },
    getCinemaList: function (cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getMerchandiseTransactions();
      } else {
        this.currentPage = event;
        this.getMerchandiseTransactions();
      }
    },
    clearDate(type) {
      this.currentPage = 1;
      this.MerchandiseTransactions = [];
      switch (type) {
        case 1:
        case "from_date":
          this.from_date = "";
          break;
        case 2:
        case "to_date":
          this.to_date = "";
          break;
      }
    },
    onchangeDate: _.debounce(function (query) {
      this.MerchandiseTransactions = [];
      this.currentPage = 1;
      this.getMerchandiseTransactions();
    }, 500),
    getMerchandiseTransactions: function (
      isExcelDownload = "N",
      exportType = "item"
    ) {
      if (!this.cinema_id) {
        return this.$toasted.show("Please select Cinema");
      } else if (!this.to_date && !this.from_date) {
        return this.$toasted.show("Please select Date");
      } else if (this.to_date && !this.from_date) {
        return this.$toasted.show("Please select From date");
      } else if (this.from_date && !this.to_date) {
        return this.$toasted.show("Please select TO date");
      } else if (moment(this.from_date).isAfter(this.to_date)) {
        return this.$toasted.show("From must be smaller than To Date");
      } else {
        let loader = this.$loading.show();
        this.MerchandiseTransactions = [];
        this.btenable = true;
        let payload = {
          fromDate: this.from_date
            ? moment(this.from_date).format("YYYY-MM-DD")
            : null,
          toDate: this.to_date
            ? moment(this.to_date).format("YYYY-MM-DD")
            : null,
          searchValue: this.searchValue,
          limit: this.perPage,
          currentPage: this.currentPage,
          cinema_id: this.cinema_id,
          isExcel: isExcelDownload || "N",
          exportType: exportType || "item",
          merch_tags: this.merch_tags ? [this.merch_tags] : []
        };

        if (isExcelDownload == "Y") {
          payload["isExcel"] = "Y";
          payload["limit"] = null;
          payload["currentPage"] = 1;
        }

        MasterService.GetMerchandiseTransactions(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.excelPath && isExcelDownload == "Y") {
              window.open(data.excelPath, "_blank");
            } else if (
              data &&
              data.status &&
              data.Records &&
              data.Records.length > 0
            ) {
              this.MerchandiseTransactions = data.Records;
              if (data.pagination.total) {
                this.rows = data.pagination.total;
              }
              this.selectedvalue = data.pagination.to - data.pagination.from;
            } else {
              this.MerchandiseTransactions = [];
              this.selectedvalue = 0;
              this.rows = 0;
              this.$toasted.show(this.$t("No Records Found"));
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          })
          .finally(() => {
            this.btenable = false;
            setTimeout(() => loader.hide(), 1000);
          });
      }
    },
  },
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}

.color-box {
  width: 15px;
  height: 15px;
  margin-bottom: 10px;
}
.color-combination {
  font-size: 12px;
}

.fw-ms {
  font-family: Arial !important;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/MechandiseComponents/MerchandiseTransactionReport.vue